import { Tooltip } from "@lockerpm/design";
import { FormCoreInput } from "../core/CoreInput";
import { FormFieldWrapper } from "../helpers/FieldWrapper";
import { FormInputWrapper } from "../helpers/InputWrapper";
import { TAILWIND_COLORS } from "#src/utils/common";
import { HelpCircle } from "@untitled-ui/icons-react";
import { ReactNode } from "react";
import { IFormCoreInputProps } from "../types";

export interface IFormInputProps extends IFormCoreInputProps {
  label: string;
  required?: boolean;
  errorText?: string | null;
  hint?: ReactNode;
  tooltip?: ReactNode;
}

export const FormInput = (props: IFormInputProps) => {
  return (
    <FormFieldWrapper
      label={props.label}
      requiredMark={props.required}
      error={props.errorText}
      hint={props.hint}
    >
      <FormInputWrapper
        invalid={Boolean(props.errorText)}
        disabled={props.disabled}
        className="px-3 py-2 gap-2"
      >
        <FormCoreInput {...props} />
        {props.tooltip ? (
          <Tooltip
            color={TAILWIND_COLORS["gray-v2-900"]}
            title={
              <p className="text-xs text-white font-semibold text-center">
                {props.tooltip}
              </p>
            }
          >
            <HelpCircle className="h-4 w-4 min-w-4 text-gray-v2-400 cursor-pointer" />
          </Tooltip>
        ) : null}
      </FormInputWrapper>
    </FormFieldWrapper>
  );
};
